/**
 * 앱 디자인 커스텀
 * src/settings.js 에서 settings.hideMenu에서 설정된다.
 * package.json의 config.preid 설정으로 분기한다.
 */

import { createContext } from 'react';
import packageJson from '../../package.json';
import { settings } from '../settings';

const preid = packageJson.config?.preid;
let hideMenu = settings.hideMenu.default;

if (preid) {
  const preidMenus = settings.hideMenu[preid];
  if (preidMenus && preidMenus.length === 0) {
    hideMenu = [];
  } else if (preidMenus) {
    hideMenu = [...settings.hideMenu.default, ...preidMenus];
  }
}

const MenuContext = createContext(hideMenu);

export default MenuContext;
